export default __webpack_public_path__ + "static/media/AICPA.ef4ccbc6.png";